var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.open)?_c(_setup.ExportDialog,{attrs:{"open":_vm.open,"cancel":_setup.handleCancel,"text-content":_setup.textContent(),"templates":_vm.templates,"formats":_vm.formats,"run-export":_setup.runExport,"track":_setup.trackExport}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }